/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useT } from 'talkr';
import OnlyOneOption from '../../components/onlyOneOption';
import questions from '../../survey/questions';
import questionsMan from '../../surveyMan/questionsMan';
import s from './index.module.scss';
import defaultOption from '../styles/defaultOption.module.scss';
import common from '../index.module.scss';
import optionsImages from '../../survey/optionsImages';
import optionsImagesMan from '../../surveyMan/optionsImagesMan';

function DefaultQuestion (props) {
	const { T } = useT();
	const { options } = props.step;
	const { name } = props.step;
	const savedQuestionValues = useSelector((state) => state.questions.savedAnswers.intermittent_fasting);
	const intermittentFastingSaved = savedQuestionValues && savedQuestionValues.value;
	const [intermittentFasting, setIntermittentFasting] = useState(intermittentFastingSaved || false);
	const planMan = useSelector((state) => state.global.planMan);
	const questionsType = planMan ? questionsMan : questions;
	const optionsImagesType = planMan ? optionsImagesMan : optionsImages;

	function actionOnClick () {
		// setTimeout(() => {
		//   steps.navigate.forward({
		//     preventAction: 500,
		//   });
		// }, 300);
	}

	function checkIfOptionSelected (answer, questionName) {
		const check = questionsType.isAnswerSelected({
			questionName,
			answer
		});

		return check;
	}

	function changeCheckbox (e) {
		setIntermittentFasting(e.target.checked);

		questionsType.setAnswer({
			questionName: 'intermittent_fasting',
			answerName: 'value',
			answerValue: e.target.checked
		});
	}

	return (
		<section className={`${common.step}`}>
			{planMan
				? <div className={common.stepTitle}>{T('diet_type_noDiet_title')}</div>
				: <div className={common.stepTitle}>{T(name)}</div>}
			<div className={common.stepDescription}>{T(`${name}_description`)}</div>

			<div className={s.options}>
				{
					options && Object.entries(options).map((option) => (
						<OnlyOneOption
							key={option[1].value}
							className={`${defaultOption.option} ${s.optionWithArrow}`}
							selectedStateClass={s.optionWithArrowSelected}
							disableFromFocus={!props.isThisCurrentStep}
							option={option[1]}
							questionName={name}
							actionOnClick={actionOnClick}
							isOptionSelected={checkIfOptionSelected(option[1].value, name)}
							// runOnChoose={() => { steps.userMovedToNextStepByClick({ byNextStep: true }); }}
						>
							<div className={defaultOption.iconWrapper}>
								<img
									className={`
                  ${planMan ? defaultOption.icon_diet : defaultOption.icon} 
                  ${checkIfOptionSelected(option[1].value, name) && defaultOption.icon_fill}`}
									src={optionsImagesType[name][option[1].value]}
									alt=""
								/>
							</div>
							<div className={s.text}>
								<div className={s.title}>{T(`${name}_${option[1].value}`)}</div>
								<p className={s.description}>{T(`${name}_${option[1].description}`)}</p>
							</div>
						</OnlyOneOption>
					))
				}
			</div>
			<div className={s.checkboxWrapper}>
				<input className={s.inputToHide} type="checkbox" onChange={changeCheckbox} id="agree" checked={intermittentFasting} tabIndex={!props.isThisCurrentStep ? -1 : ''} />
				<label className={s.checkbox} htmlFor="agree">
					{T('intermittent_fasting')}
					<div className={s.checkTumb} />
				</label>
			</div>
		</section>
	);
}

function WithOneOption (props) {
	const questionsList = useSelector((state) => state.questions.list);
	const questionName = props.stepData.name;
	const question = questionsList[questionName];
	const { isThisCurrentStep } = props;
	const { isCurrentStepCompleted } = props;
	const isThisCurrentStepClass = isThisCurrentStep ? s.stepSelected : '';
	const isThisStepCompletedClass = isCurrentStepCompleted ? s.stepCompleted : '';

	return (
		<div className={`${s.step} ${isThisCurrentStepClass} ${isThisStepCompletedClass}`}>
			<DefaultQuestion step={question} index={1} isThisCurrentStep={isThisCurrentStep} />
		</div>
	);
}

export default WithOneOption;
